"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SttDatePicker;
require("date-fns");
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _styles2 = _interopRequireDefault(require("./styles"));
var _dateFns2 = _interopRequireDefault(require("@date-io/date-fns"));
var _pt = _interopRequireDefault(require("date-fns/locale/pt"));
var _pickers = require("@material-ui/pickers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2["default"])(theme);
});
function SttDatePicker(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns2["default"],
    locale: _pt["default"]
  }, /*#__PURE__*/_react["default"].createElement(_pickers.KeyboardDatePicker, _extends({
    autoOk: true,
    variant: "inline",
    inputVariant: "outlined",
    margin: "dense",
    format: "dd/MM/yyyy",
    fullWidth: true,
    InputLabelProps: {
      classes: {
        root: classes.label,
        focused: classes.focused,
        error: classes.error
      }
    },
    InputProps: {
      classes: {
        root: classes.input,
        focused: classes.cssfocused,
        notchedOutline: classes.notchedOutline,
        disabled: classes.disabled,
        error: classes.error
      }
    },
    KeyboardButtonProps: {
      disableRipple: true
    },
    leftArrowButtonProps: {
      disableRipple: true
    },
    rightArrowButtonProps: {
      disableRipple: true
    }
  }, props)));
}